// English
export const locale = {
  lang: 'en',
  data: {
    CARD_FORM: {
      CARD_NUMBER: 'Card Number',
      EXPIRATION_DATE: 'Expiration Date',
      SECURITY_CODE: 'Security Code',
      INVALID_CARD_NUMBER: 'Invalid card number',
      CARD_NUMBER_REQUIRED: 'Card number is required',
      INVALID_EXPIRATION_DATE: 'Invalid expiration date',
      EXPIRATION_DATE_REQUIRED: 'Expiration date is required',
      CVC_REQUIRED: 'CVC is required',
      CVC_LENGTH_INVALID: 'CVC length is invalid',
      ZIP: 'ZIP code',
      ZIP_REQUIRED: 'ZIP code is required',
      SAVE_FOR_FUTURE_PAYMENTS:
        'This payment method will be saved for future payments.',
    },
    ERRORS: {
      AUTH_FAILED: 'Authentication failed',
      MISSING_TOKEN: 'Missing token query parameter',
      VALIDATION_FAILED: 'Validation failed',
      SERVER_ERROR: 'Server error',
    },
  },
};


